import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Wrapper, Header } from "./LessonStyle";
import LessonsRange from "./00_lessons_range/LessonsRange";
import Vocabulary from "./01_vocabulary/Vocabulary";
import Grammar from "./02_grammar/Grammar";
import Reading from "./03_reading/Reading";
import Listening from "./04_listening/Listening";
import Speaking from "./05_speaking/Speaking";
import {
  updateCurrentLesson,
  updateLessonsRange,
} from "../../../features/lessons/lessonSlice";

const Lesson = () => {
  const dispatch = useDispatch();

  const role = useSelector((s) => s.auth?.user?.role); // ✅ add
  const isPrivileged = role === "TEACHER" || role === "ADMIN"; // ✅ add

  const currentLesson = useSelector((state) => state.lesson.currentLesson);
  const { lessons } = useSelector((state) => state.studentLessons);

  useEffect(() => {
    // ✅ TEACHER/ADMIN: never enforce unlock list
    // Just ensure we have a valid currentLesson (fallback to 1).
    if (isPrivileged) {
      if (!currentLesson) {
        dispatch(updateCurrentLesson(1));
        dispatch(updateLessonsRange(1));
      }
      return;
    }

    // ✅ STUDENT: existing behaviour
    if (!lessons || lessons.length === 0) return;

    const currentIsUnlocked = lessons.some(
      (l) => l.order === currentLesson && l.isUnlocked
    );

    if (!currentLesson || !currentIsUnlocked) {
      const firstUnlocked = lessons.find((l) => l.isUnlocked);
      if (!firstUnlocked) return;

      const lessonNumber = firstUnlocked.order;
      dispatch(updateCurrentLesson(lessonNumber));

      let rangeNumber = 1;
      switch (true) {
        case lessonNumber < 7: rangeNumber = 1; break;
        case lessonNumber < 13: rangeNumber = 7; break;
        case lessonNumber < 19: rangeNumber = 13; break;
        case lessonNumber < 25: rangeNumber = 19; break;
        case lessonNumber < 31: rangeNumber = 25; break;
        default: break;
      }

      dispatch(updateLessonsRange(rangeNumber));
    }
  }, [lessons, currentLesson, dispatch, isPrivileged]);

  return (
    <Wrapper>
      <Header>Lesson {currentLesson}</Header>
      <LessonsRange />
      <Grammar />
      <Vocabulary />
      <Reading />
      <Listening />
      <Speaking />
    </Wrapper>
  );
};

export default Lesson;
